import { endpoints } from "consts";

export const customersPaymentUrlBuilder = {
  getCustomerBalance: ({ id }: { id: string }): string => {
    return `${endpoints.customers}/${id}/balance`;
  },
};
